import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default () => useFeatureAvailable(Feature.PROJECT_PLAN);
